// Geodesy helpers for quest-scale distances (equirectangular approximation —
// fine below a few km; plan §4.2).

export interface GeoPoint {
  lat: number
  lng: number
}

export interface GeoFix extends GeoPoint {
  accuracy: number // meters (95% radius)
  timestamp: number
}

const M_PER_DEG_LAT = 111320

/** East/North offset in meters from `origin` to `target`. */
export function enuOffset(origin: GeoPoint, target: GeoPoint): {east: number; north: number} {
  const north = (target.lat - origin.lat) * M_PER_DEG_LAT
  const east =
    (target.lng - origin.lng) * M_PER_DEG_LAT * Math.cos((origin.lat * Math.PI) / 180)
  return {east, north}
}

export function geoDistanceMeters(a: GeoPoint, b: GeoPoint): number {
  const {east, north} = enuOffset(a, b)
  return Math.hypot(east, north)
}

/** Bearing from a to b, degrees clockwise from north. */
export function geoBearingDeg(a: GeoPoint, b: GeoPoint): number {
  const {east, north} = enuOffset(a, b)
  return (Math.atan2(east, north) * 180) / Math.PI
}

/**
 * ENU meters → position in worldGroup-local space.
 * Convention (plan §4.2): +x = East, −z = North, y up.
 */
export function enuToLocal(enu: {east: number; north: number}): [number, number, number] {
  return [enu.east, 0, -enu.north]
}
